// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__sAN7W","item":"Breadcrumbs_item__oXkYU","link":"Breadcrumbs_link__hU-64"};